import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import storageDetector from './detector';

// Import all locale resources
import commonZh from './locales/zh-CN/common.json';
import pagesZh from './locales/zh-CN/pages.json';
import componentsZh from './locales/zh-CN/components.json';
import adminZh from './locales/zh-CN/admin.json';
import commonEn from './locales/en-US/common.json';
import pagesEn from './locales/en-US/pages.json';
import componentsEn from './locales/en-US/components.json';
import adminEn from './locales/en-US/admin.json';

i18n
  .use(storageDetector)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'zh-CN': {
        common: commonZh,
        pages: pagesZh,
        components: componentsZh,
        admin: adminZh,
      },
      'en-US': {
        common: commonEn,
        pages: pagesEn,
        components: componentsEn,
        admin: adminEn,
      },
    },
    fallbackLng: 'zh-CN',
    load: 'all',
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
    detection: {
      order: ['storageDetector', 'localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      lookupSessionStorage: 'i18nextLng',
    },
    // Default namespace
    defaultNS: 'common',
    ns: ['common', 'pages', 'components', 'admin'],
  });

export default i18n;
